import {
  userData,
  updateUserData,
  moneyTransfer,
} from "../../js/api/profile.js";
import { blockusers } from "../../js/api/users.js";
import { _t } from "../../services/TranslationService.js";
import Utils from "../../services/Utils.js";

let allCurrencies = [];
let user;
let UserProfile = {
  render: async () => {
    allCurrencies = [];
    let request = Utils.parseRequestURL();
    user = await userData(request.id);
    const urlParams = location.href.split('?').find(i => i.includes('state'));
    const state = urlParams?.length ? urlParams.split('=')[1] : '1';

    if (user.total_coins.includes('|')) {
      var allCoins = user.total_coins.split('|');

      for (let index = 0; index < allCoins.length; index++) {
        const coin = allCoins[index];
        const currency = coin.split(';')[0].split('.')[1];
        allCurrencies.push({
          currency,
          id: coin.split(';')[0].split('.')[0],
          value: coin.split(';')[1]
        });
      }

    } else {
      if (user.currency) {
        allCurrencies.push({
          currency: user.currency,
          id: user.currency_id,
          value: user.total_coins
        });
      } else {
        const currency = user.total_coins.split(';')[0].split('.')[1];
        const value = user.total_coins.split(';')[1];
        const id = user.total_coins.split(';')[0].split('.')[0];

        allCurrencies.push({
          currency: currency,
          id: id,
          value: value
        });
      }

    }

    let useCoinsViewProfile = ``;

    allCurrencies.forEach(currency => {
      useCoinsViewProfile += `<option value="${currency.id}">${currency.currency}</option>`;
    });

    const closeBtn = `
      <a class="closeModalBtn">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 512.001 512.001" style="enable-background:new 0 0 512.001 512.001;" xml:space="preserve">
          <g>
          \t<g>
          \t\t<path d="M284.286,256.002L506.143,34.144c7.811-7.811,7.811-20.475,0-28.285c-7.811-7.81-20.475-7.811-28.285,0L256,227.717    L34.143,5.859c-7.811-7.811-20.475-7.811-28.285,0c-7.81,7.811-7.811,20.475,0,28.285l221.857,221.857L5.858,477.859    c-7.811,7.811-7.811,20.475,0,28.285c3.905,3.905,9.024,5.857,14.143,5.857c5.119,0,10.237-1.952,14.143-5.857L256,284.287    l221.857,221.857c3.905,3.905,9.024,5.857,14.143,5.857s10.237-1.952,14.143-5.857c7.811-7.811,7.811-20.475,0-28.285    L284.286,256.002z"/>
          \t</g>
          </g>
      </svg>
      </a>
    `;

    let view = /*html*/ `
      <div class="form-list-modal-wrapper">
        <form class="form-list-modal" id="user-form">
          <div class="form-list-modal-header">
            <span>${_t('Transfero Balanca EUR')}</span>
            ${closeBtn}
          </div>
          <div class="form-list-modal-body">
            <input required="true" step="0.1" type="text" />
          </div>
          <div class="form-list-modal-footer">
            <button type="submit">${_t('Regjistro')}</button>
          </div>
        </form>
      </div>

      <div class="createUsersHeader">
        <a class="backBtn">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12" preserveAspectRatio="none"><path fill="#F8F8F8" fill-rule="evenodd" d="M6.216 12L7 11.243 1.569 6 7 .757 6.216 0 .784 5.243 0 6l.784.757z"></path></svg>
        </a>
        <span>${_t('Detaje')} - ${user.username}</span>
        <button type="button" data-child-id="${user.id}" data-state="${state === '1' ? '3' : '1'}" class="blockUnblockUserButton">${state === '1' ? _t('Blloko') : _t('Zhblloko')}</button>
      </div>

      <div class="createUsersWrapper m-t-6">
        <div class="createUsersHolder m-t-6">
          
          <div class="form-list-view">
            <div class="form-list-item">
              <span class="form-list-label">${_t('Identifikimi i fundit')}</span>
              <span class="form-list-value">--</span>
            </div>
            <a class="form-list-item" href="#">
              <span class="form-list-label">${_t('Emri')}</span>
              <span class="form-list-value" data-key="name" data-type="text">${user.name}</span>
            </a>
            <a class="form-list-item" href="#">
              <span class="form-list-label">${_t('Mbiemri')}</span>
              <span class="form-list-value" data-key="surname" data-type="text">${user.surname}</span>
            </a>
            <a class="form-list-item" href="#">
              <span class="form-list-label">${_t('Reset password')}</span>
              <span class="form-list-value" data-key="password" data-type="password"></span>
            </a>
          </div>

          <div class="form-list-view">
          ${
            allCurrencies.map(c => {
              return `
              <a class="form-list-item">
                <span class="form-list-label">${_t('Balanca')} ${Utils.currencyCode(c.currency)}</span>
                <span class="form-list-value" data-key="${c.id}" data-id="number" data-type="text">${Utils.formatNumber(c.value)}</span>
              </a>
              `
            }).join('')
          }
          </div>
        </div>
      </div>
       `;
    return view;
  },
  after_render: async () => {
    /* On Modal Form Open */
    $('a.form-list-item').unbind('click');
    $('a.form-list-item').on('click', function(e) {
      e.preventDefault();
      const modal = $('.form-list-modal-wrapper');
      $(modal).find('button[type="submit"]').removeAttr('disabled', false);
      const type = $(e.currentTarget).find('.form-list-value').attr('data-type') || 'text';
      const dataId = $(e.currentTarget).find('.form-list-value').attr('data-id');
      const key = $(e.currentTarget).find('.form-list-value').attr('data-key');
      const label = $(e.currentTarget).find('.form-list-label').text();
      const value = $(e.currentTarget).find('.form-list-value').text();

      $(modal).find('.form-list-modal-header span').text(label);
      $(modal).find('.form-list-modal-body input').attr('type', type);
      $(modal).find('.form-list-modal-body input').attr('placeholder', label);
      $(modal).find('.form-list-modal-body input').attr('name', key);
      $(modal).find('.form-list-modal-body input').attr('dataId', dataId);
      if (type !== 'number') {
        $(modal).find('.form-list-modal-body input').val(value);
        if( dataId === 'number' ){
            $(modal).find('.form-list-modal-body input').val('');
            $(modal).find('.form-list-modal-body input').attr('placeholder', _t('Shuma'));

            $(modal).find('.form-list-modal-body input').attr('id', "thisIdNumber");
            $(modal).find('.form-list-modal-body input').attr('data-id', "text");

            const inputField = document.getElementById("thisIdNumber");

            inputField.addEventListener("input", function (event) {
                const inputValue = event.target.value;

                // Define a regular expression pattern to match allowed input
                const pattern = /^-?\d*\.?\d*(,\d*)?$/;

                if (!pattern.test(inputValue)) {
                    // If the input doesn't match the pattern, clear the input value
                    event.target.value = event.target.value.slice(0, -1);
                }
            });
        }
      }

      $(modal).addClass('open');
    });

    /* Modal Close Button */
    $('.form-list-modal-wrapper .closeModalBtn').unbind('click');
    $('.form-list-modal-wrapper .closeModalBtn').on('click', function(e) {
      e.preventDefault();
      $('.form-list-modal-wrapper').removeClass('open');
    });

    /* On Modal Form Open */
    $('#user-form').unbind('submit');
    $('#user-form').on('submit', async function(e) {
      e.preventDefault();
      $(e.currentTarget).find('button[type="submit"]').attr('disabled', true);

      const input = $(e.currentTarget).find('input');
      const type = $(input).attr('type');
      const key = $(input).attr('name');
      const value = $(input).val();
      const dataId = $(input).attr('dataId');

      if (type !== 'number') {

        if (dataId === 'number'){
            const amount = parseFloat(value);
            var res = await moneyTransfer({
                user: (user.id).toString(),
                amount,
                currency: key
            });
            if (res && res.error) {
                alert(_t(res.error));
            }
            if (res && res.message) {
                alert(_t(res.message));
            }
            location.reload();
        }else {
            // For text fields and password
            const userData = {
                user: user.id,
                name: user.name,
                surname: user.surname,
                password: '',
                single_percentage: user.single_percentage,
                double_percentage: user.double_percentage,
                triple_percentage: user.triple_percentage,
                casino_enabled: user.casinoEnabled,
                partner_type: user.partner_type
            }

            userData[key] = value;
            var res = await updateUserData(userData);
            if (res && res.error) {
                alert(_t(res.error));
            }
            if (res && res.message) {
                alert(_t(res.message));
            }
            location.reload();
        }
      }
      $('.form-list-modal-wrapper').removeClass('open');
    });


    $('.blockUnblockUserButton').unbind('click');
    $('.blockUnblockUserButton').on('click', async function (e) {
      e.preventDefault()
      e.stopPropagation();
      e.stopImmediatePropagation();
      let childId = $(e.currentTarget).attr('data-child-id');
      let state = $(e.currentTarget).attr('data-state');
      var r = confirm(_t("Jeni te sigurt?"));
      if (r == true) {
        const res = await blockusers(childId, state);
        location.reload();
      }
    });
  },
  hideFooterCasino: true
};

export default UserProfile;
